/* istanbul ignore file */

/**
 * Should have all locale keys used in this project with translations matching the language-region
 * code of this file.
 */

export default {
  error: 'Error',
  warning: 'Warning',
  info: 'Information',
  success: 'Success',
  alert: {
    close: 'Close'
  }
};
